// extracted by mini-css-extract-plugin
export default {"support":"support_support__8lyz+","title__block":"support_title__block__4aDe7","title__text":"support_title__text__rKLi2"};